import React from 'react'
import { FlexCenter } from '../../lib/components'
import { ResendVerificationPresenter } from './resend-verification-email-presenter'
import { emailInputSchema } from '../../lib/utils/schema'
import { userServices } from '../../services'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { showBanner } from '../../global-state/banner-slice'
import { Verification } from '../../lib/types'
import { captureEvent } from '../../lib/utils/posthogUtils/usePostHog'
import { EVENTS } from '../../lib/utils/constants'

const initialValues = {
  email: '',
}

const ResendVerificationContainer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSubmit = async (val: any) => {
    const response = await userServices.sendVerificationLink_v1(
      val?.email,
      Verification.verifyEmail,
    )
    if (!!response && response.status === 200) {
      captureEvent(EVENTS.email_verification_link_sent, { email: val?.email })
      dispatch(
        showBanner({
          text: 'Email verification link has been sent to email successfully.',
          variant: 'success-banner',
        }),
      )
      const userId = (response.data as { userId?: number } | undefined)?.userId
      const emailLower = val?.email?.toLowerCase?.() ?? ''
      if (typeof userId === 'number' && emailLower) {
        navigate('/verify-account', { state: { email: emailLower, investorId: userId } })
      } else {
        navigate('/login')
      }
    } else {
      dispatch(
        showBanner({
          text:
            (response.data && response.data.message) || 'Something went wrong! Please try again.',
          variant: 'error-banner',
        }),
      )
    }
  }

  return (
    <FlexCenter variant={'column-center'} classes={['mt-0 center-in-page-container']}>
      <ResendVerificationPresenter
        initialValues={initialValues}
        handleFormSubmit={handleSubmit}
        validationSchema={emailInputSchema}
      />
    </FlexCenter>
  )
}

export { ResendVerificationContainer }
